export type CompanyOwnershipIdentity = { website: string | null; legalName: string | null; licence: string | null };
export const COMPANY_OWNERSHIP_SETTINGS: CompanyOwnershipIdentity = {
  website: "tashiraev.com",
  legalName: "TASHIRA E-Visa & Tourism L.L.C-FZ",
  licence: "2541485.01",
};

function required(value: string | null, field: string) {
  const normalized = value?.trim();
  if (!normalized) throw new Error(`Company ${field} is not configured`);
  return normalized;
}

export function companyDomain(website: string | null) {
  const value = required(website, "website");
  try { return new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`).hostname.replace(/^www\./i, "").toLowerCase(); }
  catch { throw new Error("Company website is invalid"); }
}

export function companyLicenceNumber(licence: string | null) {
  const value = required(licence, "licence");
  return value.match(/\d[\d.]+/)?.[0] ?? value;
}

export function companyOwnershipStatement(identity: CompanyOwnershipIdentity, language: "ar" | "en") {
  const domain = companyDomain(identity.website);
  const legalName = required(identity.legalName, "legalName");
  const licence = companyLicenceNumber(identity.licence);
  return language === "ar"
    ? `${domain} موقع مملوك ومُدار من ${legalName} — رخصة تجارية رقم ${licence}، ميدان فري زون، دبي.`
    : `${domain} is owned and operated by ${legalName} — commercial licence ${licence}, Meydan Free Zone, Dubai.`;
}
